
export default {
  namespaced: true,
  state: {
    // 全屏激活
    active: false,
    value: 0
  },
  actions: {
    /**
     * @description 初始化监听
     * @param {Object} context
     */
    // listen ({ commit }) {
    //   return new Promise(resolve => {
    //     if (screenfull.enabled) {
    //       screenfull.on('change', () => {
    //         console.log('1')
    //         if (!screenfull.isFullscreen) {
    //           commit('set', false)
    //         }
    //       })
    //     }
    //     // end
    //     resolve()
    //   })
    // },
    /**
     * @description 切换全屏
     * @param {Object} context
     */
    toggle ({ state }) {
      console.log(state)
      return new Promise(resolve => {
        if (state.active) {
          // commit('set', false)
          state.active = true
        } else {
          state.active = false
          // screenfull.request()
          // commit('set', true)
        }
        // end
        resolve()
      })
    }
  },
  mutations: {
    /**
     * @description 设置 store 里的全屏状态
     * @param {Object} state state
     * @param {Boolean} active active
     */
    set (state, active) {
      state.active = active
    }
  }
}
